import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ModuleHelper } from '../../helpers';
import { contentListQueries } from '../../queries';
import { ModuleActionsService } from '../../services/moduleActionsService';
import { isApiValidationError } from 'src/config/request/fetcher/error';
import { DataHubService } from 'src/core/services/datahub';
import { TryContentModuleNameEditSchema } from 'src/core/services/datahub/schemas/moduleList/tryContentModuleNameEditSchema';
import { Toast } from 'src/shared/components/toast';
import { HttpStatus } from 'src/shared/constants/httpStatus';
export const useRenameModuleMutation = (module) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const renameModuleMutation = useMutation({
        mutationFn: async ({ name }) => {
            if (module.name !== name) {
                return await ModuleActionsService.renameModule(module.id, name);
            }
        },
        onSuccess: (response, { name, triggerType }) => {
            queryClient.setQueryData(contentListQueries.getModules({ extra: module.extra }).queryKey, (oldData) => oldData?.map((oldModule) => module.id === oldModule.id ? { ...oldModule, name } : oldModule));
            Toast.show({ type: 'success', message: t('content_list.rename_module.success') });
            DataHubService.sendEvent({
                schema: new TryContentModuleNameEditSchema({
                    moduleType: ModuleHelper.getModuleType(module),
                    result: 'SUCCESSFUL',
                    statusCode: response?.status ?? HttpStatus.Ok,
                    failureDescription: 'NOT_FAILURE_RESULT_EVENT',
                    componentName: triggerType === 'enter' ? 'ENTER_KEY' : 'EDIT_SAVE_BUTTON'
                })
            });
        },
        onError: (error, { triggerType }) => {
            Toast.show({ type: 'danger', message: t('content_list.rename_module.success') });
            DataHubService.sendEvent({
                schema: new TryContentModuleNameEditSchema({
                    moduleType: ModuleHelper.getModuleType(module),
                    result: 'SUCCESSFUL',
                    statusCode: isApiValidationError(error)
                        ? error.statusCode
                        : HttpStatus.InternalServerError,
                    failureDescription: isApiValidationError(error) ? error.message : 'FAILURE_RESULT_EVENT',
                    componentName: triggerType === 'enter' ? 'ENTER_KEY' : 'EDIT_SAVE_BUTTON'
                })
            });
        }
    });
    return renameModuleMutation;
};
